import styled from "styled-components";

export const FilterBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  gap: 10px;
`;
